import React, { useState, useRef, useEffect } from 'react';
import './ExamQuiz.css';
import axios from 'axios';
import Spinner from './Spinner';
import {ApiKey, dataUrl} from '../config'
import ModalDiag from "./ModalDiag";
import Subscribe from './Subscribe';


const ExamQuiz = ({subject, fulllengthsubject, backToLogin}) => {
  // configs
  const examTimeout = 120 * 60;
  const scoreConfig = {
    correct: 2,        // Marks for a correct answer
    wrong: -2 / 3,     // Negative marks for a wrong answer
    unattempted: 0     // Marks for an unattempted question
  };


  const [questions, setQuestions] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [answers, setAnswers] = useState({});
  const [visitLater, setVisitLater] = useState({});
  const [timer, setTimer] = useState(examTimeout);
  const [isQuizActive, setIsQuizActive] = useState(false);
  const [showOMR, setShowOMR] = useState(false);
  const [results, setResults] = useState(null);
  const [isLoading, setIsLoading] = useState(false); // New loading state
  const omrRef = useRef(null);
  const omrButtonRef = useRef(null);
  const [SubscribeMsg, setSubscribeMsg] = useState(null);
  const modalDataInitial = 
    {
      showWarning: false,
      title: '',
      body: '',
      isLoading: false, 
      onOkay: () => null
    };
  const [modalData, setModalData] = useState(modalDataInitial);
  // todo:: generate anki for wrong answers with date as filename.
  // Load data from local storage or fetch from backend
  useEffect(() => {
    const storedState = JSON.parse(localStorage.getItem('ExamQuizState'));
    const storedResults = JSON.parse(localStorage.getItem("ExamQuizResults"));
    if (storedState && storedState.questions) {
      setQuestions(storedState.questions);
      setAnswers(storedState.answers);
      setVisitLater(storedState.visitLater);
      setTimer(storedState.timer);
      setIsQuizActive(storedState.isQuizActive);
      setCurrentPage(storedState.currentPage || 0);

      if (!storedState.isQuizActive && storedResults) {
        setResults(storedResults);
      }
    } else {
      // Get questions from backend
      fetchExamQuestions();
    }
  }, []);

  const closeEndTestWarning = () => setModalData(modalDataInitial);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideOMR = omrRef.current && omrRef.current.contains(event.target);
      const clickedOMRButton = omrButtonRef.current && omrButtonRef.current.contains(event.target);
      const clickedVisitLater = event.target.closest('.VisitLaterCB');
    
      if (showOMR && !clickedInsideOMR && !clickedOMRButton && !clickedVisitLater) {
        setShowOMR(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showOMR]);
  // Timer logic
  useEffect(() => {
    let interval;
    if (isQuizActive) {
      interval = setInterval(() => {
        setTimer((prev) => {
          const newTimer = prev - 1;
          if (newTimer <=0) {
            clearInterval(interval);
            endQuiz(); 
            return prev; 
          }
          localStorage.setItem('ExamQuizState', JSON.stringify({ ...JSON.parse(localStorage.getItem('ExamQuizState')), timer: newTimer }));
          return newTimer;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isQuizActive]);

  // Save state to local storage on change
  useEffect(() => {
    if (questions.length > 0) {
      localStorage.setItem('ExamQuizState', JSON.stringify({
        questions,
        answers,
        visitLater,
        timer,
        isQuizActive,
        currentPage
      }));
    }
  }, [questions, answers, visitLater, timer, isQuizActive, currentPage]);

  // Simulate fetching questions
  const fetchExamQuestions = async () => {
    // Replace with actual API call
      setIsLoading(true);
      var req = {
        email: localStorage.getItem('user'),
        method: "GetExamMCQs",
        subject: subject,
        params: {
          ...(fulllengthsubject?.split(',').length === 2 && { MCQsubject: fulllengthsubject })        }
      };
      const headers = { 
        'x-api-key': ApiKey
      };
      axios.post( dataUrl, req, { withCredentials: true, headers:headers}).then(resp=>{
    
    //axios.post('http://localhost:3004', req).then(resp=>{
    const base64Content = resp.data;
    // Decode base64 and parse JSON
    let parsedContent;
    try {
      const binaryString = atob(base64Content);
      const utf8Decoder = new TextDecoder('utf-8'); // Create a UTF-8 decoder
      const jsonString = utf8Decoder.decode(Uint8Array.from(binaryString, char => char.charCodeAt(0)));
      parsedContent = JSON.parse(jsonString);
      if(Array.isArray(parsedContent))
      {
      setQuestions(parsedContent);
      setIsQuizActive(true);
      localStorage.setItem('ExamQuizState', JSON.stringify({ questions: parsedContent, answers: {}, visitLater: {}, timer: 0, isQuizActive: true }));
      }
      else if (parsedContent?.body && typeof parsedContent.body === "string")
      {
        var msg = JSON.parse(parsedContent.body); 

        if (msg.message === "Your subscription not valid. Please subscribe to get the exam questions") {
          // Show subscription prompt
          setSubscribeMsg(msg.message);
          setIsQuizActive(false);
          return;
        }
      }

      
    } catch (e) {
      console.log("Error decoding or parsing content:", e);
      return; // Exit if decoding/parsing fails
    }
    }).catch(err => {console.log(err);})
    .finally(() => {
      setIsLoading(false); // Stop loading when done (success or error)
    });
    };

  // Handle answer selection via OMR
  const handleAnswer = (qIndex, option) => {
    if (!answers.hasOwnProperty(qIndex))
      setAnswers((prev) => ({ ...prev, [qIndex]: option }));
  };

  // Handle visit later
  const handleVisitLater = (qIndex) => {
    setVisitLater((prev) => ({ ...prev, [qIndex]: !prev[qIndex] }));
  };
  const questionsPerPage = 6;
  // Pagination
  const totalPages = Math.ceil(questions.length / questionsPerPage);
  const options = ["A", "B", "C", "D"]; // Define answer option key
  // End quiz
  const endQuiz = () => {
    setModalData(modalDataInitial);
    setIsQuizActive(false);
    const result = {
      totalCorrect: 0,
      totalWrong: 0,
      subjectWise: {},
      details: [],
    };
    questions.forEach((q, i) => {
      const isCorrect = answers[i] === q.Answer;
      if (answers[i]) {
        result.totalCorrect += isCorrect ? 1 : 0;
        result.totalWrong += !isCorrect ? 1 : 0;
      }
      result.subjectWise[q.subject] = result.subjectWise[q.subject] || { correct: 0, wrong: 0, unattempted: 0};
      if (answers[i]) {
        result.subjectWise[q.subject][isCorrect ? 'correct' : 'wrong'] += 1;
      }
      else
        result.subjectWise[q.subject]['unattempted'] += 1

      result.details.push({ qIndex:i , myAnswer: answers[i] });
    });
    localStorage.setItem("ExamQuizResults", JSON.stringify(result));
    setResults(result);
  };
  if(SubscribeMsg)
  {
    return(
      <Subscribe msg={SubscribeMsg} backToLogin={backToLogin} />
    );
  }
  if (!isQuizActive && results) {
    const totalUnattempted = questions.length - (results.totalCorrect + results.totalWrong); 
    const score = results.totalCorrect * scoreConfig.correct + results.totalWrong * scoreConfig.wrong;

    return (
      <div className="Feedback">
        <h1>Feedback & Results<br/>(Click on Finished Review button to complete the review)</h1>
        <div className="results-grid">
          <div className="results-column">
            <p>Total Correct: <b>{results.totalCorrect}</b></p>
            <p>Total Wrong: <b>{results.totalWrong}</b></p>
            <p>Total Unattempted: <b>{totalUnattempted}</b></p>
          </div>
          
          <div className="score-column">
            <p>Total Score: <b>{score.toFixed(2)}</b></p>
          </div>
        </div>
        <div className="feedbacksubjectwise">
        {Object.entries(results.subjectWise).map(([subject, { correct, wrong, unattempted }]) => (
          <div key={subject} className="feedbacksubject-section">
            <h2>{subject}</h2>
            <p>✅ Correct: {correct}</p> 
            <p>❌ Wrong: {wrong}</p>
            <p> ⏳ Unattempted: {unattempted}</p>
            <p> Number of Questions asked: {correct + wrong + unattempted}</p>
          </div>
        ))}</div>
        <h2>Self Review</h2>
        {results.details.map((d, i) => (
            <div key={i} className={`review-question ${d.myAnswer ? (d.myAnswer === questions[d.qIndex].Answer ? "feedbackcorrect" : "feedbackincorrect") : "feedbackunattempted"}`}>
          <div key={i}>
            <div className="ExamMCQQuestion" dangerouslySetInnerHTML={{ __html: questions[d.qIndex].Question}} />
            {options.map((option) => (
                  <div key={option}  className={answers.hasOwnProperty(d.qIndex) && answers[d.qIndex] === option ? "option-selected" : ""}>
                    ({option}){questions[d.qIndex]?.[option]}
                  </div>
                ))}
            <p>{d.question}</p>
            <p>My Answer: {d.myAnswer || 'Not Answered'}</p>
            <p>Correct Answer: {questions[d.qIndex].Answer}</p>
            <div className="ExamMCQExplanation" dangerouslySetInnerHTML={{ __html: questions[d.qIndex].Explanation}} />
          </div>
          </div>
        ))}
        <button 
              className="donereviewbtn"
              onClick={() => {
                localStorage.removeItem('ExamQuizState'); 
                localStorage.removeItem("ExamQuizResults");
                window.location.reload();
                }}>Finished Review</button>
      </div>
    );
  }
  function ShowThatQuestionPage(qindex)
  {
    setShowOMR(false);
    setCurrentPage(Math.floor((qindex -1) / questionsPerPage));
  }
  return (
    <div className={`examquiz-container ${showOMR ? "omr-open" : ""}`}>
      { isLoading && <Spinner wholepage={true} />}
      <div className="timerCountDown">
      Time: {Math.floor(timer / 60)}:{timer %60 < 10 ? `0${timer%60}` : timer%60}
    </div>
      <div className="main-content">
      <div className="questions-grid">
        {questions.slice(currentPage * questionsPerPage, (currentPage + 1) * questionsPerPage).map((q, i) => {
          const qIndex = currentPage * questionsPerPage + i;
          return (
            <div
              key={qIndex}
              className={`question mb-0 questionborder ${answers[qIndex] ? 'QuestionAnswered' : visitLater[qIndex] ? 'QuestionMarkedLater' : 'QuestionBackground'}`}
            >
              <div>
              <div className="ExamMCQQuestion" dangerouslySetInnerHTML={{ __html: `${qIndex + 1}. ${q.Question}` }} />
                {options.map((option) => (
                  <div key={option}  className={answers.hasOwnProperty(qIndex) && answers[qIndex] === option ? "option-selected" : ""}>
                    ({option}){questions[qIndex]?.[option]}
                  </div>
                ))}
              </div>
              <label className='VisitLaterCB'>
                <input
                  type="checkbox"
                  checked={visitLater[qIndex] || false}
                  onChange={() => handleVisitLater(qIndex)}
                />
                Visit Later
              </label>
            </div>
          );
        })}
      </div>
      </div>
      {(
      <div ref={omrRef} className={"omr " +  (showOMR && "open top-[30px] pb-[35px] md:top-0 md:pb-[100px]")}>
          <h3>OMR Sheet</h3>
          <div className="omr-list">
            {
            Array.from({ length: questions.length }, 
              (_, qIndex) => (
              <div key={qIndex} className={"omr-item " + (answers[qIndex] ? "answeredomr" : (visitLater[qIndex]===true ?  "visitlateromr" : ""))}>
                <span className="question-number" onClick={() => ShowThatQuestionPage(qIndex+1)}>{qIndex + 1}.</span>
                    {options.map((opt) => (
                      <button key={opt} className={`omr-option w-6 h-6 rounded-full border border-[var(--textmain1)] ${answers[qIndex] === opt ? 'selected' : ''}`} onClick={() => handleAnswer(qIndex, opt)}>
                        {opt}
                      </button>
                ))}
              </div>
          ))}
          </div>
          </div>
      )
      }
      <div className="ExamMcqNavigation flex flex-wrap justify-center items-center gap-2 p-2 md:p-4">
        <button disabled={currentPage === 0} onClick={() => {setCurrentPage(currentPage - 1); ; window.scrollTo({ top: 0, behavior: 'smooth' });}}>Previous</button>
        <button ref={omrButtonRef} onClick={(e) => {e.stopPropagation(); setShowOMR(!showOMR)}}>OMR</button>
        <button disabled={currentPage === totalPages - 1} onClick={() => {setCurrentPage(currentPage + 1); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Next</button>
        <button onClick={() => setModalData({
          showWarning: true,
          title: '',
          body: 'Are you sure you want to end the test?',
          isLoading: false,
          onOkay:() => endQuiz()
        })}>End Test</button>
      </div>
    {modalData.showWarning===true && (<div className='WarningDiag'><ModalDiag  title={modalData.title} body={modalData.body} closeModal={closeEndTestWarning} onOkay={modalData.onOkay} isLoading={modalData.isLoadingModal} onCancel={closeEndTestWarning}/></div>)}

    </div>
    );
};

export default ExamQuiz;